import { SideBar } from '../../models/sideBar.model';
import { assets } from '../constants/assets.const';
import { ModuleConst } from './keys.const';

export const sideBar: SideBar[] = [
  {
    sideBarId: 1,
    label: 'Dashboard',
    link: '/dashboard',
    icon: assets.dashboard,
    tooltip: 'Dashboard',
    module_id: ModuleConst.Dashboard,
    can_be_delete: false,
    can_add_edit: false,
    can_view: false
  },
  {
    sideBarId: 2,
    label: 'UsersManagement',
    link: '/manage-users',
    icon: assets.manageUsers,
    tooltip: 'Users Management',
    module_id: ModuleConst.User,
    can_be_delete: false,
    can_add_edit: false,
    can_view: false
  },
  {
    sideBarId: 3,
    label: 'LoyaltyPointsManagement',
    link: '/manage-loyalty',
    icon: assets.loyaltyIcon,
    tooltip: 'LoyaltyPointsManagement',
    module_id: ModuleConst.Loyality,
    can_be_delete: false,
    can_add_edit: false,
    can_view: false
  },
  {
    sideBarId: 4,
    label: 'ManageBorrowing',
    link: '/manage-borrowing',
    icon: assets.borrowIcon,
    tooltip: 'ManageBorrowing',
    module_id: ModuleConst.Borrowing,
    can_be_delete: false,
    can_add_edit: false,
    can_view: false
  },
  {
    sideBarId: 5,
    label: 'Referrals',
    link: '/referral',
    icon: assets.referIcon,
    tooltip: 'Referrals ',
    module_id: ModuleConst.Referrals,
    can_be_delete: false,
    can_add_edit: false,
    can_view: false
  },
  {
    sideBarId: 6,
    label: 'WalletManagement',
    link: '/wallet',
    icon: assets.walletIcon,
    tooltip: 'WalletManagement',
    module_id: ModuleConst.Wallet,
    can_be_delete: false,
    can_add_edit: false,
    can_view: false
  },
  {
    sideBarId: 7,
    label: 'RevenueManagement',
    link: '/revenue',
    icon: assets.revenueManagement,
    tooltip: 'RevenueManagement',
    module_id: ModuleConst.Revenue,
    can_be_delete: false,
    can_add_edit: false,
    can_view: false
  },
  {
    sideBarId: 8,
    label: 'AdBannerManagement',
    link: '/manage-banner',
    icon: assets.adbannerIcon,
    tooltip: 'AdBannerManagement',
    module_id: ModuleConst.Banner,
    can_be_delete: false,
    can_add_edit: false,
    can_view: false
  },
  {
    sideBarId: 9,
    label: 'NotificationManagement',
    link: '/manage-notifications',
    icon: assets.notificationmanagement,
    tooltip: 'NotificationManagement',
    module_id: ModuleConst.Notification,
    can_be_delete: false,
    can_add_edit: false,
    can_view: false
  },
  {
    sideBarId: 10,
    label: 'ManageSubAdmin',
    link: '/subadmin',
    icon: assets.subadmin,
    tooltip: 'ManageSubAdmin',
    module_id: ModuleConst.Subadmin,
    can_be_delete: false,
    can_add_edit: false,
    can_view: false
  },
  {
    sideBarId: 11,
    label: 'ManageCustomerSupport',
    link: '/customer-support',
    icon: assets.customerSupport,
    tooltip: 'ManageCustomerSupport',
    module_id: ModuleConst.Support,
    can_be_delete: false,
    can_add_edit: false,
    can_view: false
  },
  {
    sideBarId: 12,
    label: 'ManageCMSPages',
    link: '/manage-cms',
    icon: assets.cmspages,
    tooltip: 'ManageCMSPages',
    module_id: ModuleConst.Cms,
    can_be_delete: false,
    can_add_edit: false,
    can_view: false
  },
  {
    sideBarId: 13,
    label: 'ManageTransaction',
    link: '/manage-transaction',
    icon: assets.settings,
    tooltip: 'ManageTransaction',
    module_id: ModuleConst.ManageTransaction,
    can_be_delete: false,
    can_add_edit: false,
    can_view: false
  },
  {
    sideBarId: 14,
    label: 'MerchantSetting',
    link: '/merchant-settings',
    icon: assets.settings,
    tooltip: 'MerchantSetting',
    module_id: ModuleConst.MerchantSetting,
    can_be_delete: false,
    can_add_edit: false,
    can_view: false
  },
  {
    sideBarId: 15,
    label:'WalletTopup',
    link:'/wallet-topup',
    icon:assets.walletIcon,
    tooltip:'WalletTopup',
    module_id:ModuleConst.WalletTopupComponent,
    can_be_delete:false,
    can_add_edit:false,
    can_view:false
  }
];
